module.exports = __webpack_public_path__ + "static/media/COTI-BNB.5cfe534e.svg";